module.exports = __webpack_public_path__ + "media/images/products/IMG_20210704_164347_HDR-removebg-preview-15937f7519c63d225518e3de2753c517.png";